import { render } from "./BannerPub.vue?vue&type=template&id=245dccde&scoped=true"
import script from "./BannerPub.vue?vue&type=script&lang=js"
export * from "./BannerPub.vue?vue&type=script&lang=js"

import "./BannerPub.vue?vue&type=style&index=0&id=245dccde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245dccde"]])

export default __exports__